import * as Colors from 'material-ui/styles/colors';

export default {
  editBox: {
    border: `1px solid ${Colors.limeA700}`,
    position: 'absolute',
    userSelect: 'none',
    boxSizing: 'border-box',
    display: 'flex',
  },
  multiSelectBoundingBox: {
    border: '1px dashed black',
    position: 'absolute',
    userSelect: 'none',
    boxSizing: 'border-box',
  }
};
